import React, { Component } from "react";
import "./AddressList.css";
import Footer from "../../component/Footer/Footer";
import LayoutWrapper from "../../component/LayoutWrapper/";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import PropTypes from "prop-types";
import { newAddressAdd, doAddNewAddressRes } from '../../action/AddNewAddressAction';
import { addressShowList, doShowAddressListRes } from '../../action/ShowAddressListAction';
import { addressDelete, doDeleteAddressRes } from '../../action/DeleteAddressAction';
import { showBillingAddress, doShowBillingRes } from '../../action/ShowBillingAction';
import { updateBillingAdd, doBillingUpdateRes } from '../../action/billingUpdateAction';
import loaderImg from "../../assets/images/loader-example.gif";
import Loader from "react-loader-advanced";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";

class AddressList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddressSubmited: false,
      showAddressData: [],
      isLoader: false,
      addressShow: true,
      newAddrModalPopup: false,
      firstName: '',
      lastName: '',
      company: '',
      streetAddress: '',
      City: '',
      postalCode: '',
      phoneNumber: '',
      addressBook: '',
      stateProvince: '',
      addradio: localStorage.getItem('addressId') ? localStorage.getItem('addressId') : 0,

      billingName: '',
      billingStreetaddress: '',
      billingCity: '',
      billingPostalcode: '',
      billingStateProvince: '',
      copyChecked: false,
    };
    ReactGA.initialize("UA-64201999-5");
    ReactGA.pageview(window.location.pathname + window.location.search);

    ReactPixel.init("784849368913134");

    ReactPixel.pageView();
  }

  componentDidMount() {
    const data = {
      user_id: localStorage.getItem('userId')
    }
    this.setState({
      isLoader: true,
    })

    this.props.addressShowList(data)
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.doAddNewAddressRes && nextProps.doAddNewAddressRes.user) {
      if (nextProps.doAddNewAddressRes.user && nextProps.doAddNewAddressRes.user.AddNewAddressRes) {
        if (nextProps.doAddNewAddressRes.user.AddNewAddressRes && nextProps.doAddNewAddressRes.user.AddNewAddressRes.result === true) {
          window.location.href = ''
          this.setState({
            newAddrModalPopup: false,
            addressShow: true,
            isLoader: false
          }, () => {
            if (this.state.addressShow) {
              const data = {
                user_id: localStorage.getItem('userId')
              }
              this.props.addressShowList(data)
            }
          })
        } else {
          this.setState({
            isLoader: false,
            newAddrModalPopup: false
          })
        }
      }
    }

    if (nextProps.doShowAddressListRes && nextProps.doShowAddressListRes.user) {
      if (nextProps.doShowAddressListRes.user && nextProps.doShowAddressListRes.user.ShowAddressListRes) {
        if (nextProps.doShowAddressListRes.user.ShowAddressListRes && nextProps.doShowAddressListRes.user.ShowAddressListRes.result === true && this.state.addressShow) {
          this.setState({
            showAddressData: nextProps.doShowAddressListRes.user.ShowAddressListRes.address,
            addressID: nextProps.doShowAddressListRes.user.ShowAddressListRes.address[0].id,
            addressShow: false,
            isLoader: false,
          })
        } else {
          this.setState({
            isLoader: false
          })
        }
      }
    }

    if (nextProps.doDeleteAddressRes && nextProps.doDeleteAddressRes.user) {
      if (nextProps.doDeleteAddressRes.user && nextProps.doDeleteAddressRes.user.DeleteAddressRes) {
        if (nextProps.doDeleteAddressRes.user.DeleteAddressRes && nextProps.doDeleteAddressRes.user.DeleteAddressRes.results === true) {
          window.location.href = '/address-info'
          this.setState({
            isLoader: false
          })
        } else {
          this.setState({
            isLoader: false
          })
        }
      }
    }

    if (nextProps.doShowBillingRes && nextProps.doShowBillingRes.user) {
      if (nextProps.doShowBillingRes.user && nextProps.doShowBillingRes.user.ShowBillingRes) {
        if (nextProps.doShowBillingRes.user.ShowBillingRes && nextProps.doShowBillingRes.user.ShowBillingRes.result === true) {

          this.setState({
            newAddrModalPopup: true,
            billingName: nextProps.doShowBillingRes.user.ShowBillingRes.billing.name,
            billingStreetaddress: nextProps.doShowBillingRes.user.ShowBillingRes.billing.address,
            billingCity: nextProps.doShowBillingRes.user.ShowBillingRes.billing.city,
            billingPostalcode: nextProps.doShowBillingRes.user.ShowBillingRes.billing.pincode,
            billingStateProvince: nextProps.doShowBillingRes.user.ShowBillingRes.billing.state,
          })
        }
      }
    }

    if (nextProps.doBillingUpdateRes && nextProps.doBillingUpdateRes.user) {
      if (nextProps.doBillingUpdateRes.user && nextProps.doBillingUpdateRes.user.UpdateBillingRes) {
        if (nextProps.doBillingUpdateRes.user.UpdateBillingRes && nextProps.doBillingUpdateRes.user.UpdateBillingRes.success === true) {
          this.setState({
            newAddrModalPopup: false,
            isLoader: false
          })
        } else {
          this.setState({
            isLoader: false
          })
        }
      }
    }


  }

  deleteAddress = (id) => {
    const data = {
      add_id: id
    }
    this.setState({
      isLoader: true
    })
    this.props.addressDelete(data)

  }


  addressvalidate(values) {
    const errors = {};
    if (values.firstName && values.firstName.trim() === '') {
      errors.firstName = '*Please enter firstName';
    } else if (values.firstName === undefined) {
      errors.firstName = '*Please enter firstName';
    } else if (values.firstName === '') {
      errors.firstName = '*Please enter firstName';
    }

    if (values.lastName && values.lastName.trim() === '') {
      errors.lastName = '*Please enter lastName';
    } else if (values.lastName === null) {
      errors.lastName = '*Please enter lastName';
    } else if (values.lastName === undefined) {
      errors.lastName = '*Please enter lastName';
    } else if (values.lastName === '') {
      errors.lastName = '*Please enter lastName';
    }

    if (values.company && values.company.trim() === '') {
      errors.company = '*Please enter company';
    } else if (values.company === null) {
      errors.company = '*Please enter company';
    } else if (values.company === undefined) {
      errors.company = '*Please enter company';
    } else if (values.company === '') {
      errors.company = '*Please enter company';
    }

    if (values.streetAddress && values.streetAddress.trim() === '') {
      errors.streetAddress = '*Please enter streetAddress';
    } else if (values.streetAddress === null) {
      errors.streetAddress = '*Please enter streetAddress';
    } else if (values.streetAddress === undefined) {
      errors.streetAddress = '*Please enter streetAddress';
    } else if (values.streetAddress === '') {
      errors.streetAddress = '*Please enter streetAddress';
    }

    if (values.city && values.city.trim() === '') {
      errors.city = '*Please enter city';
    } else if (values.city === null) {
      errors.city = '*Please enter city';
    } else if (values.city === undefined) {
      errors.city = '*Please enter city';
    } else if (values.city === '') {
      errors.city = '*Please enter city';
    }

    if (values.postalCode && values.postalCode.trim() === '') {
      errors.postalCode = '*Please enter postalCode';
    } else if (values.postalCode === null) {
      errors.postalCode = '*Please enter postalCode';
    } else if (values.postalCode === undefined) {
      errors.postalCode = '*Please enter postalCode';
    } else if (values.postalCode === '') {
      errors.postalCode = '*Please enter postalCode';
    }


    if (values.phoneNumber && values.phoneNumber.trim() === '') {
      errors.phoneNumber = '*Please enter phoneNumber';
    } else if (values.phoneNumber === null) {
      errors.phoneNumber = '*Please enter phoneNumber';
    } else if (values.phoneNumber === undefined) {
      errors.phoneNumber = '*Please enter phoneNumber';
    } else if (values.phoneNumber === '') {
      errors.phoneNumber = '*Please enter phoneNumber';
    } else if (values.phoneNumber.length !== 10) {
      errors.phoneNumber = '*Please enter valid phone number.';
    }


    if (values.stateProvince && values.stateProvince.trim() === '') {
      errors.stateProvince = '*Please enter state';
    } else if (values.stateProvince === null) {
      errors.stateProvince = '*Please enter state';
    } else if (values.stateProvince === undefined) {
      errors.stateProvince = '*Please enter state';
    } else if (values.stateProvince === '') {
      errors.stateProvince = '*Please enter state';
    }

    if (values.billingName && values.billingName.trim() === '') {
      errors.billingName = '*Please enter billing name';
    } else if (values.billingName === undefined) {
      errors.billingName = '*Please enter billing name';
    } else if (values.billingName === '') {
      errors.billingName = '*Please enter billing name';
    }

    if (values.billingStreetaddress && values.billingStreetaddress.trim() === '') {
      errors.billingStreetaddress = '*Please enter billing address';
    } else if (values.billingStreetaddress === null) {
      errors.billingStreetaddress = '*Please enter billing address';
    } else if (values.billingStreetaddress === undefined) {
      errors.billingStreetaddress = '*Please enter billing address';
    } else if (values.billingStreetaddress === '') {
      errors.billingStreetaddress = '*Please enter billing address';
    }

    if (values.billingCity && values.billingCity.trim() === '') {
      errors.billingCity = '*Please enter billing city';
    } else if (values.billingCity === null) {
      errors.billingCity = '*Please enter billing city';
    } else if (values.billingCity === undefined) {
      errors.billingCity = '*Please enter billing city';
    } else if (values.billingCity === '') {
      errors.billingCity = '*Please enter billing city';
    }

    if (values.billingStateProvince && values.billingStateProvince.trim() === '') {
      errors.billingStateProvince = '*Please enter state';
    } else if (values.billingStateProvince === null) {
      errors.billingStateProvince = '*Please enter state';
    } else if (values.billingStateProvince === undefined) {
      errors.billingStateProvince = '*Please enter state';
    } else if (values.billingStateProvince === '') {
      errors.billingStateProvince = '*Please enter state';
    }

    if (values.billingPostalcode && values.billingPostalcode.trim() === '') {
      errors.billingPostalcode = '*Please enter billing postal code';
    } else if (values.billingPostalcode === null) {
      errors.billingPostalcode = '*Please enter billing postal code';
    } else if (values.billingPostalcode === undefined) {
      errors.billingPostalcode = '*Please enter billing postal code';
    } else if (values.billingPostalcode === '') {
      errors.billingPostalcode = '*Please enter billing postal code';
    }


    return errors;
  }


  AddressHandelSubmit = e => {
    e.preventDefault();
    this.setState({
      isAddressSubmited: true,
    }, () => { });
    this.addressvalidate(this.state);
    const errors = this.addressvalidate(this.state);
    if (Object.keys(errors).length === 0) {
      let requestData = {
        user_id: localStorage.getItem('userId'),
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        company: this.state.company,
        streetAddress: this.state.streetAddress,
        city: this.state.city,
        postalCode: this.state.postalCode,
        phoneNumber: this.state.phoneNumber,
        stateProvince: this.state.stateProvince
        // addressBook:this.state.addressBook,
      }
      let billingData = {
        user_id: localStorage.getItem('userId'),
        name: this.state.billingName,
        address: this.state.billingStreetaddress,
        city: this.state.billingCity,
        state: this.state.billingStateProvince,
        pincode: this.state.billingPostalcode
      }
      this.setState({
        isLoader: true
      })
      this.props.updateBillingAdd(billingData)
      this.props.newAddressAdd(requestData)
    }
  }

  addressHandelChange = (e) => {
    this.setState({
      addradio: e
    })
    localStorage.setItem('addressId', e)
  }

  clickNewAddress() {
    this.setState({
      newAddrModalPopup: true
    })
    const shipdata = {
      user_id: localStorage.getItem('userId')
    }
    this.props.showBillingAddress(shipdata)
  }

  onCloseModal = () => {
    this.setState({
      newAddrModalPopup: false
    })
  }

  handleChangeCheckBox = e => {
    if (e.target.checked === true) {
      this.setState({
        copyChecked: e.target.checked,
        firstName: this.state.billingName,
        streetAddress: this.state.billingStreetaddress,
        city: this.state.billingCity,
        stateProvince: this.state.billingStateProvince,
        postalCode: this.state.billingPostalcode
      });
    } else {
      this.setState({
        copyChecked: false,
        firstName: '',
        streetAddress: '',
        city: '',
        stateProvince: '',
        postalCode: ''
      });
    }

  }



  logOut = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  render() {
    // const content = this.state.checked
    const { newAddrModalPopup } = this.state;
    const errors = this.addressvalidate(this.state);
    const { isAddressSubmited } = this.state;
    const spinner = (
      <span>
        <img src={loaderImg} alt="" />
      </span>
    );
    const closeIcon = (
      <i className="fa fa-times closeIconbg add-clr-btn" aria-hidden="true"></i>
    );
    return (
      <React.Fragment>
        <Loader show={this.state.isLoader} message={spinner}>
          <LayoutWrapper />

          <main className="main">
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <div className="container">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Address
                  </li>
                </ol>
              </div>
              {/* End .container  */}
            </nav>
            <div className="container">
              <div className="row">
                <div className="col-lg-9 order-lg-last dashboard-content">
                  <h2>Address Information</h2>

                  <div className="row">
                    <div className="col-lg-8">
                      <ul className="checkout-steps">
                        <li>
                          <div onClick={() => this.clickNewAddress()}><a href="/" className="btn btn-sm btn-outline-secondary btn-new-address " data-toggle="modal" data-target="#addressModal" >+ New Address</a></div>
                          <div className="shipping-step-addresses">
                            {
                              this.state.showAddressData && this.state.showAddressData.map((item, i) => (
                                <div className="shipping-address-box" key={i}>
                                  <i className="fa fa-trash-alt del-add" onClick={() => this.deleteAddress(item.id)}></i>
                                  {/* </a> */}
                                  <address>
                                    {item.first_name} {item.last_name} <br />
                                    {item.street_address},{item.city} {item.zip_code}<br />
                                    {item.state} <br />
                                    {item.phone_number}<br />
                                  </address>

                                  <input type="radio" name="addradio" onClick={() => this.addressHandelChange(item.id)} checked={(this.state.addradio === item.id) ? true : ((i === 0) ? true : false)} value={item.id} readOnly />
                                </div>

                              ))
                            }

                          </div>
                          {/* End .shipping-step-addresses */}


                        </li>



                      </ul>
                    </div>
                    {/* End .col-lg-8 */}


                  </div>

                </div>
                {/* End .col-lg- */}

                <aside className="sidebar col-lg-3">
                  <div className="widget widget-dashboard">
                    <h3 className="widget-title">My Account</h3>

                    <ul className="list">
                      <li>
                        <a href="/profile-update">Account Details</a>
                      </li>
                      {/* <li><a href="my-account.html#">Account Information</a></li>
                                                    <li><a href="/checkoutshippingaddress">Address Book</a></li>
                                                    <li><a href="/order-history">My Orders</a></li> */}

                      <li>
                        <a href="/my-wallet">My Wallet</a>
                      </li>
                      <li className="active">
                        <a href="/address-info">Address Info</a>
                      </li>
                      <li>
                        <a href="/change-password">Change-Password</a>
                      </li>
                      {/* <li><a href="my-account.html#">Recurring Profiles</a></li>
                                                    <li><a href="my-account.html#">My Product Reviews</a></li>*/}
                      <li>
                        <a href="/order-history">My Order</a>
                      </li>
                      <li><a href="/corporate-order-history">Corporate Order</a></li>
                      <li>
                        <span
                          className="logoutLi"
                          onClick={() => this.logOut()}
                        >
                          Logout
                        </span>
                      </li>
                    </ul>
                  </div>
                  {/* End .widget */}
                </aside>
                {/* End .col-lg-3 */}
              </div>
              {/* End .row */}
            </div>
            {/* End .container  */}
            <div className="mb-5"></div>
            {/* margin  */}
          </main>
          {/* End .main */}
        </Loader>

        <Modal open={newAddrModalPopup} onClose={this.onCloseModal} closeIcon={closeIcon} >
          <Loader show={this.state.isLoader} >
            <form onSubmit={this.AddressHandelSubmit} className="bg-color-login">
              <div className="modal-header">
                <h3 className="modal-title" id="addressModalLabel">Add Address</h3>
              </div>
              {/* End .modal-header */}
              <div className="modal-body">
                <label className="modal-title pad-10">Billing Address</label>

                <div className="form-group required-field">

                  <label>Name </label>
                  <input type="text" className="form-control form-control-sm" name="billingname" onChange={(e) => this.setState({ billingName: e.target.value })} value={this.state.billingName || ''} autoComplete="off" />
                  {errors && isAddressSubmited && <span className="error-message">{errors.billingName}</span>}

                </div>
                <div className="form-group required-field">

                  <label>Street Address </label>
                  <input type="text" className="form-control form-control-sm" name="billingstreetadd" onChange={(e) => this.setState({ billingStreetaddress: e.target.value })} value={this.state.billingStreetaddress || ''} autoComplete="off" />
                  {errors && isAddressSubmited && <span className="error-message">{errors.billingStreetaddress}</span>}

                </div>
                {/* End .form-group */}

                <div className="form-group required-field">
                  <label>City  </label>


                  <input type="text" className="form-control form-control-sm" name="billingCity" onChange={(e) => this.setState({ billingCity: e.target.value })} value={this.state.billingCity || ""} autoComplete="off" />
                  {errors && isAddressSubmited && <span className="error-message">{errors.billingCity}</span>}


                </div>
                {/* End .form-group */}

                <div className="form-group">
                  <label>State/Province</label>

                  <input type="text" className="form-control form-control-sm" name="billingStateProvince" onChange={(e) => this.setState({ billingStateProvince: e.target.value })} value={this.state.billingStateProvince || ""} autoComplete="off" />
                  {errors && isAddressSubmited && <span className="error-message">{errors.billingStateProvince}</span>}


                  {/* End .select-custom */}
                </div>
                {/* End .form-group */}

                <div className="form-group required-field">
                  <label>Zip/Postal Code </label>


                  <input type="text" className="form-control form-control-sm" name="billingPostalcode" onChange={(e) => this.setState({ billingPostalcode: e.target.value })} value={this.state.billingPostalcode || ""} autoComplete="off" />
                  {errors && isAddressSubmited && <span className="error-message">{errors.billingPostalcode}</span>}


                </div>

                <hr className='dashed-line' />
                <label className="modal-title pad-10">Shipping Address</label>
                <div>
                  <input type="checkbox" id="vehicle1" name="vehicle1" checked={this.state.copyChecked} onChange={this.handleChangeCheckBox} />
                  <label className="pl-2 " for="vehicle1"><b> Same as billing address</b></label>
                </div>

                <div className="form-group required-field">
                  <label>First Name </label>
                  <input type="text" className="form-control form-control-sm" name="firstname" onChange={(e) => this.setState({ firstName: e.target.value })} value={this.state.firstName || ""} autoComplete="off" />
                  {errors && isAddressSubmited && <span className="error-message">{errors.firstName}</span>}
                </div>
                {/* End .form-group */}

                <div className="form-group required-field">
                  <label>Last Name </label>
                  <input type="text" className="form-control form-control-sm" name="lastname" onChange={(e) => this.setState({ lastName: e.target.value })} value={this.state.lastName || ""} autoComplete="off" />
                  {errors && isAddressSubmited && <span className="error-message">{errors.lastName}</span>}
                </div>
                {/* End .form-group */}

                <div className="form-group">
                  <label>Company </label>
                  <input type="text" className="form-control form-control-sm" name="company" onChange={(e) => this.setState({ company: e.target.value })} value={this.state.company || ""} autoComplete="off" />
                  {errors && isAddressSubmited && <span className="error-message">{errors.company}</span>}
                </div>
                {/* End .form-group */}

                <div className="form-group required-field">
                  <label>Street Address </label>
                  <input type="text" className="form-control form-control-sm" name="streetaddress" onChange={(e) => this.setState({ streetAddress: e.target.value })} value={this.state.streetAddress || ""} autoComplete="off" />
                  {errors && isAddressSubmited && <span className="error-message">{errors.streetAddress}</span>}

                </div>
                {/* End .form-group */}

                <div className="form-group required-field">
                  <label>City  </label>
                  <input type="text" className="form-control form-control-sm" name="city" onChange={(e) => this.setState({ city: e.target.value })} value={this.state.city || ""} autoComplete="off" />
                  {errors && isAddressSubmited && <span className="error-message">{errors.city}</span>}
                </div>
                {/* End .form-group */}

                <div className="form-group">
                  <label>State/Province</label>
                  <input type="text" className="form-control form-control-sm" name="stateProvince" onChange={(e) => this.setState({ stateProvince: e.target.value })} value={this.state.stateProvince || ""} autoComplete="off" />
                  {errors && isAddressSubmited && <span className="error-message">{errors.stateProvince}</span>}
                  {/* End .select-custom */}
                </div>
                {/* End .form-group */}

                <div className="form-group required-field">
                  <label>Zip/Postal Code </label>
                  <input type="text" className="form-control form-control-sm" name="postalcode" onChange={(e) => this.setState({ postalCode: e.target.value })} value={this.state.postalCode || ""} autoComplete="off" />
                  {errors && isAddressSubmited && <span className="error-message">{errors.postalCode}</span>}
                </div>
                {/* End .form-group */}

                <div className="form-group required-field">
                  <label>Phone Number </label>
                  <div className="form-control-tooltip">
                    <input type="text" className="form-control form-control-sm" name="phoneNumber" value={this.state.phoneNumber || ""} onChange={(e) => this.setState({ phoneNumber: e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1') })} autoComplete="off" />
                    {errors && isAddressSubmited && <span className="error-message">{errors.phoneNumber}</span>}
                  </div>
                  {/* End .form-control-tooltip */}
                </div>
                {/* End .form-group */}
              </div>
              {/* End .modal-body  */}

              <div className="modal-footer">
                <button type="button" className="btn btn-sm" data-dismiss="modal" onClick={this.onCloseModal} >Cancel</button>
                <button type="submit" className="btn btn-primary btn-sm show-color">Save changes</button>
              </div>
              {/* End .modal-footer */}
            </form>
            {/* </div> */}
            {/* End .modal-content */}

          </Loader>
        </Modal>
        <Footer />
      </React.Fragment>
    );
  }
}

AddressList.propTypes = {
  doAddNewAddressRes: PropTypes.any,
  doShowAddressListRes: PropTypes.any,
  doDeleteAddressRes: PropTypes.any,
  doShowBillingRes: PropTypes.any,
  doBillingUpdateRes: PropTypes.any
};

const mapStateToProps = createStructuredSelector({
  doAddNewAddressRes: doAddNewAddressRes,
  doShowAddressListRes: doShowAddressListRes,
  doDeleteAddressRes: doDeleteAddressRes,
  doShowBillingRes: doShowBillingRes,
  doBillingUpdateRes: doBillingUpdateRes
});

function mapDispatchToProps(dispatch) {
  return {
    newAddressAdd: (data) => dispatch(newAddressAdd(data)),
    addressShowList: (data) => dispatch(addressShowList(data)),
    addressDelete: (data) => dispatch(addressDelete(data)),
    showBillingAddress: (data) => dispatch(showBillingAddress(data)),
    updateBillingAdd: (data) => dispatch(updateBillingAdd(data))
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(AddressList);
